import React, { useEffect } from "react";
import { MotifSelect, MotifFormField,  MotifOption} from '@ey-xd/motif-react';

type SelectBoxType = {
    options: {label : string, value: string}[]; 
    value: string;
    onChange: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    filter?: boolean | ((x?: any) => void) | undefined;
    searchPlaceholder? : string;
    defaultValue?: string;
    visibleOptions?: number;
    placeholder?: string;
    disabled?: boolean;
    multiple?: boolean;
    onChangeHandlerPayee?: (index:number, payeeId: string) => void;
    index?: number;

}

export default function SelectBox ({ options, value, defaultValue, onChange,onChangeHandlerPayee, filter, index, searchPlaceholder, visibleOptions,placeholder,disabled,multiple}: SelectBoxType) {
    useEffect(() => {
        const btn = document.querySelectorAll('.motif-select-input') as NodeListOf<Element>;
        btn.forEach((element: Element) => {
            (element as HTMLElement).setAttribute('type', 'button');
        });
    },[]);
    const selectedValue = value || defaultValue || '';

    const onChangeHandlerEvent = (val : any) => {
        onChangeHandlerPayee && onChangeHandlerPayee(index || 0, val);
        onChange(val);
    }

    return (
        <> 
            <MotifFormField role="group"> 
                {/*@ts-ignore */}
                <MotifFormField>
                    <MotifSelect
                        ariaLabelledBy="select-label"
                        onChange={onChangeHandlerEvent}
                        value={selectedValue}
                        filter={filter}
                        searchPlaceholder={searchPlaceholder}
                        visibleOptions={visibleOptions}
                        placeholder={placeholder}
                        disabled={disabled === true ? true : false}
                        multiple={multiple}
                    >
                        {
                            options.map( option => (
                                <MotifOption isSelected={option.value === selectedValue} key={option.value+Math.random()*100} value={option.value}>{option.label}</MotifOption>
                            ))
                        }
                    </MotifSelect>
                </MotifFormField> 
            </MotifFormField>
        </>
        
    );
}